var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"SubSidenav"}},[_c('ul',{staticClass:"panel"},_vm._l((_vm.analysisTypes),function(a,index){return _c('li',{key:index,class:{ 'link-active': _vm.isSelected(index) },on:{"click":function($event){_vm.saveAnalisisPantalla({
          endpoint: a.endpoint,
          selected: index,
        });
        _vm.tabRetro();}}},[_c('a',{attrs:{"href":"#"}},[_vm._v(" "+_vm._s(a.analysisTitle)+" "),_c('span',{staticClass:"arrow"})])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }